import { Divider as CoreDivider, InputLabel as CoreInputLabel } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Divider = styled(CoreDivider)`
  margin: 10px 0;
`;

export const InputLabel = styled(CoreInputLabel)`
  width: 25%;
  white-space: nowrap;

  ${variables.mediaQuery.lessThan('desktop')`
    width: auto;
  `}
`;

export const MarginLeft = styled.span`
  margin-left: 10px;
`;
